import { ContainerJourneyReleaseResponseDto, NumericReleasesApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { axiosUnwrapper } from '@planning/app/utils'
import { PaginatedStore } from '@planning/stores/PaginatedStore'
import { makeObservable } from 'mobx'

export class NumericReleaseContainerAssignmentPaginationStore extends PaginatedStore<ContainerJourneyReleaseResponseDto> {
  constructor(numericReleaseId: number) {
    super(async (_, __, sortingModel, filter, showCompleted) => {
      return axiosUnwrapper(
        createApiClient(NumericReleasesApi).getAvailableContainers(
          numericReleaseId,
          1,
          25,
          filter,
          showCompleted,
          sortingModel.orderBy,
          sortingModel.isDescending,
        ),
      )
    })
    makeObservable(this, {})
  }
}
